
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { SHOW_EDIT_USER_INTERESTS_MODAL_QUERY_PARAM, SHOW_SELECT_USER_INTERESTS_MODAL_QUERY_PARAM, SUPPRESS_INTERESTS_MODAL_LOCALSTORAGE_KEY, USER_INTERESTS_MODAL_STATE, } from '@/src/constants';
import { PROFILE } from '@/src/constants/routes';
const shouldOpenInterestsModal = ({ isUserInterestsDeepLinked, shouldSuppressModal, sawLessThanXDaysAgo, selectedUserInterests, }) => {
    if (isUserInterestsDeepLinked)
        return true;
    if (shouldSuppressModal)
        return false;
    if (sawLessThanXDaysAgo)
        return false;
    if (selectedUserInterests?.length === 0)
        return true;
    return false;
};
const propTypes = {
    selectedUserInterests: PropTypes.arrayOf(PropTypes.number).isRequired,
    modalLastSeenDate: PropTypes.string,
    setModalState: PropTypes.func.isRequired,
    userIsOptedIn: PropTypes.bool
};
const useShowUserInterestsModals = (selectedUserInterests, 
/* istanbul ignore next */
interestsPickerShownAt = null, setModalState, userIsOptedIn = false) => {
    const numberOfDaysToSuppressModal = parseInt(process.env.REACT_APP_USER_INTEREST_MODAL_SUPPRESSION_DAYS, 10) || 14;
    const router = useRouter();
    const isUserInterestsDeepLinked = router.query?.[SHOW_SELECT_USER_INTERESTS_MODAL_QUERY_PARAM] === 'true';
    const isOptInDeepLinked = router.query?.[SHOW_EDIT_USER_INTERESTS_MODAL_QUERY_PARAM] === 'true';
    useEffect(() => {
        const shouldSuppressModal = localStorage.getItem(SUPPRESS_INTERESTS_MODAL_LOCALSTORAGE_KEY) === 'true';
        let sawLessThanXDaysAgo = false;
        if (interestsPickerShownAt) {
            sawLessThanXDaysAgo =
                interestsPickerShownAt &&
                    new Date(interestsPickerShownAt) >
                        new Date(Date.now() - numberOfDaysToSuppressModal * 24 * 60 * 60 * 1000);
        }
        const openUserInterestsModal = shouldOpenInterestsModal({
            isUserInterestsDeepLinked,
            shouldSuppressModal,
            sawLessThanXDaysAgo,
            selectedUserInterests
        });
        if (router.pathname !== PROFILE) {
            setModalState(USER_INTERESTS_MODAL_STATE.NONE);
        }
        else if (openUserInterestsModal) {
            setModalState(USER_INTERESTS_MODAL_STATE.INTERESTS);
        }
        else if (isOptInDeepLinked && !userIsOptedIn) {
            setModalState(USER_INTERESTS_MODAL_STATE.OPT_IN);
        }
        else {
            setModalState(USER_INTERESTS_MODAL_STATE.NONE);
        }
        if (shouldSuppressModal) {
            localStorage.removeItem(SUPPRESS_INTERESTS_MODAL_LOCALSTORAGE_KEY);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
useShowUserInterestsModals.propTypes = propTypes;
export default useShowUserInterestsModals;

    async function __Next_Translate__getStaticProps__195ca0f5861__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/UserPanel/UserInterests/hooks/useShowUserInterestsModals',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0f5861__ as getStaticProps }
  